import axios from 'axios';
import store from '@/store';
import {showMessage} from "@/utils/index";

let service = axios.create({
    baseURL: '/api', // api的base_url
    timeout: 5000 // 请求超时时间
});

service.interceptors.request.use(
    config => {
        if (store.state.user.is_login) {
            config.headers = {
                Authorization: store.state.user.access_token, //携带权限参数
            };
        }
        return config;
    }, error => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code) {
            showMessage(res.message);
            return Promise.reject(res)
        } else { // res.code === 0 : 成功返回
            return res;
        }
    }, async error => {
        let {response} = error;
        if (response.status === 401) {
            if (store.state.user.remember_me) {
                await store.dispatch('rememberMe');
                return await service.request(error.config);
            } else {
                await showMessage('请先登录哦！');
                await store.dispatch('logout');
            }
        } else if (response.status >= 500) {
            await showMessage('系统繁忙！');
        } else {
            await showMessage(response.data && response.data.message || response.data.error_description ||'参数有误！');
        }
        return Promise.reject(error);
    }
);

export default service
